import React from "react";
import { Breadcrumb, Row, Col, Space, Card } from "antd";
import { BrowserRouter as Router, NavLink } from "react-router-dom";
function ComponentSetting() {
  return (
    <div>
      <Breadcrumb style={{ margin: "16px 0" }}>
        <Breadcrumb.Item>Master Settings </Breadcrumb.Item>
        <Breadcrumb.Item>Components Settings</Breadcrumb.Item>
      </Breadcrumb>
      <div className="site-layout-background">
        <h2 className="titles">
          COMPONENTS <span>SETTINGS</span>
        </h2>
        <p>Select View</p>
        <Row>
          <Col xs={12} xl={8}>
            <div className="LinksCard">
              <NavLink to="/new-component">
                <span className="icons icon-new-receipt"></span>
                Add New Components
              </NavLink>
            </div>
          </Col>
          <Col xs={12} xl={8}>
            <div className="LinksCard">
              <NavLink to="/components-list">
                <span className="icons icon-component-data"></span>
                View / Manage Components
              </NavLink>
            </div>
          </Col>
        </Row>
      </div>
      <div className="site-layout-background">
        <Row>
          <Col xs={12} xl={8}>
            <div className="LinksCard">
              <NavLink to="/new-component-family">
                <span className="icons icon-new-receipt"></span>
                Add New Components Family
              </NavLink>
            </div>
          </Col>
          <Col xs={12} xl={8}>
            <div className="LinksCard">
              <NavLink to="/components-family">
                <span className="icons icon-view-all-receipt"></span>
                View / Manage Components Family
              </NavLink>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
}

export default ComponentSetting;
